import { formatDistanceToNow } from "date-fns";

/**
 * Format a date for display in the chat list (e.g. "5 minutes ago").
 * Returns empty string for undefined date.
 */
export function formatChatListTime(date: Date | undefined): string {
  if (!date) {
    return "";
  }
  return formatDistanceToNow(date, { addSuffix: true });
}

const DEFAULT_MESSAGE_PREVIEW_LENGTH = 50;
const NO_MESSAGES_LABEL = "No messages yet";

/**
 * Truncate message preview for chat list. Returns placeholder when message is falsy.
 */
export function truncateChatMessage(
  message: string | undefined,
  maxLength: number = DEFAULT_MESSAGE_PREVIEW_LENGTH
): string {
  if (!message) {
    return NO_MESSAGES_LABEL;
  }
  return message.length > maxLength ? `${message.substring(0, maxLength)}...` : message;
}
